export enum CookieItemKeyEnum {
  appUserLoggedIn = 'appuser_logged_in',
  officeFile = 'office_file',
}
